import {ValidationStateModel} from './validation-state.model';

export class ValidationResultModel {
    public source: string;
    public state: ValidationStateModel;
    public memberNames: string[];
    public errorMessage: string;
    public relatedUIElement: string;

    constructor() {
        this.state = new ValidationStateModel();
    }
}
